"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBaseSampleRate = void 0;
var BILLING_PLAN_PERFORMANCE_UNITS = 100000;
var INVOCATIONS_PER_WEEKDAY = 1500000;
var MONTHLY_INVOCATIONS = INVOCATIONS_PER_WEEKDAY * 5 * 4;
var UNITS_PER_INVOCATION = 1.3;
var TRACES_SAMPLE_RATE = BILLING_PLAN_PERFORMANCE_UNITS / (MONTHLY_INVOCATIONS * UNITS_PER_INVOCATION);

function getBaseSampleRate() {
  return TRACES_SAMPLE_RATE;
}

exports.getBaseSampleRate = getBaseSampleRate;